import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable, ReplaySubject } from 'rxjs';
import { NetforumInvoiceDetails, NetforumInvoice } from 'lms-api';
import { LmsAppSettings } from 'lms-api';

@Injectable({
  providedIn: 'root'
})
export class UserInvoiceService {
  public Invoices$: ReplaySubject<NetforumInvoice[]>;
  public Loaded$: ReplaySubject<boolean>;

  constructor(private httpClient: HttpClient, private LmsAppSettings: LmsAppSettings) { 
    this.Invoices$ = new ReplaySubject<NetforumInvoice[]>();
    this.Loaded$ = new ReplaySubject<boolean>();
    this.Loaded$.next(false);
    this.Refresh();
  }

  private FetchInvoices(forceRefresh: boolean = false): Observable<NetforumInvoice[]> {
    this.Loaded$.next(false);
    let url = this.LmsAppSettings.pac_base_nf_url + 'api/Invoice/Get';
    if(forceRefresh) url += '?refresh=1';
    return this.httpClient.get<any[]>(url).pipe(
      map(invArray => {
        let invResult = [];
        invArray.forEach(inv => {
          let nfi = new NetforumInvoice(inv);
          if(nfi.HasCELines) {
            invResult.push(nfi);
          }
        });
        invResult.sort((a, b) => {
          if(a.inv_trx_date > b.inv_trx_date) return -1;
          if(a.inv_trx_date < b.inv_trx_date) return 1;
          if(a.inv_code > b.inv_code) return -1;
          if(a.inv_code < b.inv_code) return 1;
          return 0;
        })

        this.Invoices$.next(invResult);
        this.Loaded$.next(true);
        return invResult;
      })
    )
  }

  public Refresh(forceRefresh: boolean = false) {
    this.FetchInvoices(forceRefresh).subscribe();
  }
}
